const routes = [
  {
    path: 'interstellartravel',
    name: 'interstellartravel',
    component: () => import(/* webpackChunkName: "interstellartravel" */ '@/modules/interstellartravel/index.vue')
  },
];

export default routes;